import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import StatsCard from "components/StatsCard";
import { ReactComponent as CheckInIcon } from "assets/img/icons/smile-filled.svg";
import CheckInStatsDetails from "./CheckInStatsDetails";

export default ({ team_id }) => {
  const [stats, setStats] = useState({});
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailsOpened, setDetailsOpened] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await TeamService.getCheckInStats(team_id, time);
        setStats(response?.data?.data);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [team_id, time]);

  return (
    <StatsCard
      title="Check-In Stats"
      Icon={CheckInIcon}
      loading={loading}
      stats={stats}
      time={time}
      setTime={setTime}
      onDetailsOpen={() => setDetailsOpened(true)}
      onDetailsClosed={() => setDetailsOpened(false)}
      backgroundClass="card-yellow"
      statsClass="mt-30"
    >
      <CheckInStatsDetails
        team_id={team_id}
        time={time}
        setTime={setTime}
        opened={detailsOpened}
      />
    </StatsCard>
  );
};
